import React, {useEffect, useState} from 'react'

import { connect } from 'react-redux'
import {NavLink, useLocation} from "react-router-dom";
import {settingsMenus} from "../../../../root/Routes/Routes";
import { useTranslation } from 'react-i18next';




const LeftSide: React.FC<any> = ({ leftMenuStatus }) => {
    const {t} = useTranslation();
    const location = useLocation();
    const settingsMenus = [
        {
            label: t("settings.userProfile"),
            path: '/settings'
        },
        {
            label: t("login.changePasswordTitle"),
            path: '/settings/change_password'
        },
        // {
        //   label : 'Hesablar',
        //   path : '/settings/accounts'
        // },
        // {
        //   label : 'Vidjetlər',
        //   path : '/settings/widgets'
        // },
        // {
        //   label : 'Şirkətin profili',
        //   path : '/settings/company_profile'
        // }
        // {
        //   label : i18next.t("home.accounts"),
        //   path : '/settings/accounts'
        // },
        // {
        //   label : i18next.t("settings.widgets"),
        //   path : '/settings/widgets'
        // },
        // {
        //   label : i18next.t("settings.companyProfile"),
        //   path : '/settings/company_profile'
        // }
    ]

    return (
        <>
            <div className={'settings_sides settings_left_side'} >
                <ul className={'flex direction_column full settings_list setting_left_menus'} >
                    {settingsMenus?.map((item: object, index: number) => {
                        let li_class=item.path==location.pathname ? 'active' : '';
                        return (
                            <li className={li_class} >
                                <NavLink to={item.path} activeClassName={'active'} exact={true} >
                                    {t(item.label)}
                                </NavLink>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </>
    )
}
const mapStateToProps = (state: any) => ({
    leftMenuStatus: state.home.leftMenuStatus,
});

export default connect(mapStateToProps, null)(LeftSide);
